// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"44":"477e54a843ee064deb30","210":"bacb9b661f146e916dd8"}[chunkId] + ".bundle.js";
};